// src/redux/actions/callActions.js

export const INCOMING_CALL = "INCOMING_CALL";
export const ACCEPT_CALL = "ACCEPT_CALL";
export const END_CALL = "END_CALL";
export const SET_CALL_OFFER = "SET_CALL_OFFER";
export const CLEAR_CALL_OFFER = "CLEAR_CALL_OFFER";
export const SET_ACTIVE_CALL = "SET_ACTIVE_CALL";

export const incomingCall = (data) => ({ type: INCOMING_CALL, payload: data });
export const acceptCall = () => ({ type: ACCEPT_CALL });
export const endCall = () => ({ type: END_CALL });
export const setCallOffer = (offer) => ({ type: SET_CALL_OFFER, payload: offer });
export const clearCallOffer = () => ({ type: CLEAR_CALL_OFFER });
export const setActiveCall = (data) => ({ type: SET_ACTIVE_CALL, payload: data });
